import { jsxs, jsx } from "react/jsx-runtime";
import { Skeleton } from "@mui/material";
import { SkeletonWrapper, SkeletonDetailsWrapper } from "./employee-select.styles.js";
import "@mui/material/styles";
const EmployeeAutocompleteSkeleton = () => /* @__PURE__ */ jsxs(SkeletonWrapper, { children: [
  /* @__PURE__ */ jsxs(SkeletonDetailsWrapper, { children: [
    /* @__PURE__ */ jsx(Skeleton, { variant: "circular", width: 16, height: 16 }),
    /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", width: "100%", height: 16 })
  ] }),
  /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", width: "100%", height: 2 })
] });
export {
  EmployeeAutocompleteSkeleton
};
